import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { first, Subject, tap } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ZapierService {
  /** Emit each time a request to zapier is ask */
  public requestEmit = new Subject<void>()

  private _http = inject(HttpClient)

  /** Use to sent a request access api
   * @param { string } email
   * @param { string } accountIds
   */
  public requestAccessApi(email: string, accountIds: string): void {
    const url = new URL('https://hooks.zapier.com/hooks/catch/5442384/36yvyyr/')
    url.searchParams.append('email', email)
    url.searchParams.append('accountIds', accountIds)
    this.sendHttp(url)
  }

  /**
   * Use to get more information about maximize
   * @param { string } email
   * @param { string } accountIds
   * @param { string } comment
   */
  public getMoreInformationAboutMaximize(
    email: string,
    accountIds: string,
    customerId: string,
    comment: string
  ): void {
    const url = new URL(
      'https://hooks.zapier.com/hooks/catch/5442384/3hshkff/' // to define
    )
    url.searchParams.append('email', email)
    url.searchParams.append('accountIds', accountIds)
    url.searchParams.append('customerId', customerId)
    url.searchParams.append('comment', comment)

    this.sendHttp(url)
  }

  /**
   * Send http request
   * @param {string} url
   */
  private sendHttp(url: URL): void {
    this._http
      .get(url.toString())
      .pipe(
        first(),
        tap(() => {
          this.requestEmit.next()
        })
      )
      .subscribe()
  }
}
